import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/x.png'


const _hoisted_1 = { class: "pt-[20px] pr-[0px] bg-[#ededed]" }
const _hoisted_2 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_3 = { class: "lg:pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]" }
const _hoisted_4 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_5 = { class: "pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]" }
const _hoisted_6 = { class: "overflow-x-auto shadow mt-4 mb-[3%]" }
const _hoisted_7 = { class: "w-full border-[1px] text-left lg:text-xl" }
const _hoisted_8 = {
  key: 0,
  class: "border-b-2"
}
const _hoisted_9 = { class: "w-[8%] font-medium p-3" }
const _hoisted_10 = { class: "w-[30%] font-medium p-3" }
const _hoisted_11 = { class: "w-[16%] font-medium p-3" }
const _hoisted_12 = { class: "w-[16%] font-medium p-3" }
const _hoisted_13 = { key: 1 }

import { ref } from 'vue'
    import tiptelNavigation from '@/components/SubNavigations/TheTiptelNavigation.vue'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import ContactsTable from '@/components/Contacts/ContactsTable.vue'
    import { makeABackendCall } from '@/BaseViewFunctionality'
    import { useContactStore as useStore } from '@/stores/ContactStore'
    import useContactStore from '@/utils/useContactStore'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Tiptel',
  setup(__props) {

    const contactStore = useStore()
    const { selectedContact, contacts, loading, fetchContacts } = useContactStore()
    const formRef = ref(null)

    async function fetchDataOnMounted() {
        await fetchContacts({ limit: 50, offset: 0, filter: '' })
    }

    fetchDataOnMounted()

    selectedContact.value = {}
    selectedContact.value.person = {}
    selectedContact.value.organisation = {}
    selectedContact.value.billing = {}
    selectedContact.value.message = ''

    const searchTerm = ref('')

    // functions defined and used here

    function search() {
        makeABackendCall({
            promise: contactStore.fetchContactsSearch,
            parameters: { limit: 50, offset: 0, filter: searchTerm.value },
            loading: loading.value,
        })
    }

    function deselect() {
        const text = selectedContact.value.message
        selectedContact.value = {}
        selectedContact.value.person = {}
        selectedContact.value.organisation = {}
        selectedContact.value.billing = {}
        selectedContact.value.message = text
    }

    // functions exported

    function load({ done }: { done: Function }) {
        makeABackendCall({
            promise: contactStore.fetchContactsLimit,
            parameters: {
                limit: 5,
                offset: contacts.value.length,
                filter: searchTerm.value,
                done: done,
            },
            loading: loading.value,
        })
    }

    function selectContact(contact: object) {
        const text = selectedContact.value.message
        selectedContact.value = contact
        selectedContact.value.message = text
    }

    function stripObjectRecursive(object: object) {
        for (const key in object) {
            if (typeof object[key] === 'object') {
                stripObjectRecursive(object[key])
            } else if (typeof object[key] === 'string') {
                object[key] = object[key].trim()
            }
        }
    }

    function onSubmitted() {
        selectedContact.value = {}
        selectedContact.value.person = {}
        selectedContact.value.organisation = {}
        selectedContact.value.billing = {}
        selectedContact.value.message = ''
    }

    function submit() {
        formRef.value?.validate().then((isValid) => {
            if (isValid.valid) {
                stripObjectRecursive(selectedContact.value)
                makeABackendCall({
                    promise: contactStore.createMessage,
                    parameters: {
                        message: selectedContact.value,
                        success: onSubmitted,
                    },
                    loading: loading.value,
                })
            } else {
                if (window.confirm('Fehlende Eingaben oder falsches Format. Trotzdem senden?')) {
                    stripObjectRecursive(selectedContact.value)
                    makeABackendCall({
                        promise: contactStore.createMessage,
                        parameters: {
                            message: selectedContact.value,
                            success: onSubmitted,
                        },
                        loading: loading.value,
                    })
                } else {
                    alert('Die Email wurde nicht gesendet.')
                }
            }
        })
    }

    // Rules / validation (Regex) - to be discussed with Teresa etc.

    const rules = {
        required: (value: string) => !!value || 'Bitte ausfüllen',
        email(value: string) {
            return value
                ? /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
                      'E-mail muss gültig sein'
                : true
        },
        phone(value: string) {
            return value
                ? /^((\+?|00)\d{1,3}[ -]?)?(\(0\))?(\(?\d{1,4}\)?[ -]?)?\d{1,4}[ -]?\d{1,4}[ -]?\d{1,4}$/.test(
                      value
                  ) || 'Nummer muss gültig sein'
                : true
        },
        prename(value: string) {
            return value
                ? /^[a-zA-ZäöüÄÖÜßéèêà\'\- ]+$/.test(value) || 'Vorname muss gültig sein'
                : true
        },
        secondname(value: string) {
            return value
                ? /^[a-zA-ZäöüÄÖÜßéèêà\'\- ]+$/.test(value) || 'Zweitname muss gültig sein'
                : true
        },
        name(value: string) {
            return value
                ? /^[a-zA-ZäöüÄÖÜßéèêà\'\-]+$/.test(value) || 'Name muss gültig sein'
                : true
        },
        streetname(value: string) {
            return value
                ? /^[a-zA-ZäöüÄÖÜßéèêà\'\- ]+$/.test(value) || 'Strasse muss gültig sein'
                : true
        },
        streetnumber(value: string) {
            return value
                ? /^[0-9]{1,4}[A-Za-z]{0,2}$/.test(value) || 'Nummer muss gültig sein'
                : true
        },
        zip(value: string) {
            return value ? /^[0-9]{4,5}$/.test(value) || 'PLZ muss gültig sein' : true
        },
        city(value: string) {
            return value ? /^[\p{L} \-().]{2,}$/u.test(value) || 'Stadt muss gültig sein' : true
        },
        requiredFields() {
            const phone = selectedContact.value.person.phone
            const mobile = selectedContact.value.person.mobile
            return phone || mobile ? true : 'Bitte Telefon und/oder Mobile ausfüllen'
        },
    }

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(tiptelNavigation)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_card, {
          class: "w-full mx-auto",
          color: "grey-lighten-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  loading: _unref(loading),
                  density: "comfortable",
                  type: "input",
                  onInput: _cache[0] || (_cache[0] = ($event: any) => (search())),
                  variant: "solo",
                  label: "Institution, Vorname oder Nachname suchen",
                  title: "Schule eingeben",
                  autofocus: "",
                  modelValue: searchTerm.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchTerm).value = $event)),
                  "append-inner-icon": "mdi-magnify",
                  "single-line": "",
                  "hide-details": ""
                }, null, 8, ["loading", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(ContactsTable, {
          load: load,
          hasActions: true,
          contacts: _unref(contacts),
          selectMethod: selectContact,
          contactsCount: 5
        }, null, 8, ["contacts"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _cache[16] || (_cache[16] = _createElementVNode("thead", { class: "text-white" }, [
              _createElementVNode("tr", { class: "border-b-[1px] border-black bg-[#545656] py-2" }, [
                _createElementVNode("th", { class: "w-[8%] font-medium p-3" }, "ID"),
                _createElementVNode("th", { class: "w-[30%] font-medium p-3" }, "Organisation"),
                _createElementVNode("th", { class: "w-[16%] font-medium p-3" }, "Name"),
                _createElementVNode("th", { class: "w-[16%] font-medium p-3" }, "Vorname"),
                _createElementVNode("th", { class: "w-[10%] font-medium p-3 text-center" }, "Abwählen")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_unref(selectedContact).contactId)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                    _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(selectedContact).contactId), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(selectedContact).organisation.name), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(selectedContact).person.familyName), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(selectedContact).person.firstName), 1),
                    _createElementVNode("td", { class: "w-[10%] font-medium p-3" }, [
                      _createElementVNode("button", {
                        onClick: deselect,
                        class: "w-full"
                      }, [...(_cache[14] || (_cache[14] = [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "Abwählen",
                          class: "lg:w-[35px] w-[20px] mx-auto"
                        }, null, -1)
                      ]))])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("tr", _hoisted_13, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("td", { class: "w-[8%] font-medium p-3" }, null, -1),
                    _createElementVNode("td", { class: "w-[30%] font-medium p-3" }, "Noch keinen Kontakt ausgewählt", -1)
                  ]))]))
            ])
          ])
        ]),
        _createVNode(_component_v_form, {
          onSubmit: _withModifiers(submit, ["prevent"]),
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, { fluid: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  style: {"width":"33.3333%","display":"inline-block"},
                  class: "p-[5px]",
                  rules: [rules.prename, rules.required],
                  modelValue: _unref(selectedContact).person.firstName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(selectedContact).person.firstName) = $event)),
                  label: "Vorname*",
                  placeholder: "Max",
                  type: "text"
                }, null, 8, ["rules", "modelValue"]),
                _createVNode(_component_v_text_field, {
                  style: {"width":"33.3333%","display":"inline-block"},
                  class: "p-[5px]",
                  rules: [rules.secondname],
                  modelValue: _unref(selectedContact).person.secondName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(selectedContact).person.secondName) = $event)),
                  label: "Zweitname",
                  placeholder: "Michael",
                  type: "text"
                }, null, 8, ["rules", "modelValue"]),
                _createVNode(_component_v_text_field, {
                  style: {"width":"33.3333%","display":"inline-block"},
                  class: "p-[5px]",
                  rules: [rules.name, rules.required],
                  modelValue: _unref(selectedContact).person.familyName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(selectedContact).person.familyName) = $event)),
                  label: "Name*",
                  placeholder: "Mustermann",
                  type: "text"
                }, null, 8, ["rules", "modelValue"]),
                _createVNode(_component_v_text_field, {
                  style: {"width":"25%","display":"inline-block"},
                  class: "p-[5px]",
                  rules: [rules.phone, rules.requiredFields],
                  modelValue: _unref(selectedContact).person.phone,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(selectedContact).person.phone) = $event)),
                  label: "Telefon",
                  placeholder: "+4179 123 4567",
                  type: "input"
                }, null, 8, ["rules", "modelValue"]),
                _createVNode(_component_v_text_field, {
                  style: {"width":"25%","display":"inline-block"},
                  class: "p-[5px]",
                  rules: [rules.phone, rules.requiredFields],
                  modelValue: _unref(selectedContact).person.mobile,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(selectedContact).person.mobile) = $event)),
                  label: "Mobil",
                  placeholder: "+4179 123 4567",
                  type: "input"
                }, null, 8, ["rules", "modelValue"]),
                _createVNode(_component_v_text_field, {
                  style: {"width":"25%","display":"inline-block"},
                  class: "p-[5px]",
                  rules: [rules.email, rules.required],
                  modelValue: _unref(selectedContact).person.email,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(selectedContact).person.email) = $event)),
                  label: "E-Mail*",
                  placeholder: "max.mustermann@gmail.com",
                  type: "email"
                }, null, 8, ["rules", "modelValue"]),
                _createVNode(_component_v_text_field, {
                  style: {"width":"25%","display":"inline-block"},
                  class: "p-[5px]",
                  rules: [rules.email],
                  modelValue: _unref(selectedContact).person.email_2,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(selectedContact).person.email_2) = $event)),
                  label: "E-Mail 2",
                  placeholder: "erika.mustermann@gmail.com",
                  type: "email"
                }, null, 8, ["rules", "modelValue"]),
                _createVNode(_component_v_text_field, {
                  style: {"width":"25%","display":"inline-block"},
                  class: "p-[5px]",
                  rules: [rules.streetname],
                  modelValue: _unref(selectedContact).person.streetName,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(selectedContact).person.streetName) = $event)),
                  label: "Strasse",
                  placeholder: "Musterstrasse",
                  type: "text"
                }, null, 8, ["rules", "modelValue"]),
                _createVNode(_component_v_text_field, {
                  style: {"width":"25%","display":"inline-block"},
                  class: "p-[5px]",
                  rules: [rules.streetnumber],
                  modelValue: _unref(selectedContact).person.streetNumber,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(selectedContact).person.streetNumber) = $event)),
                  label: "Hausnummer",
                  placeholder: "123",
                  type: "input"
                }, null, 8, ["rules", "modelValue"]),
                _createVNode(_component_v_text_field, {
                  style: {"width":"25%","display":"inline-block"},
                  class: "p-[5px]",
                  rules: [rules.zip],
                  modelValue: _unref(selectedContact).person.zip,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(selectedContact).person.zip) = $event)),
                  label: "PLZ",
                  placeholder: "1234",
                  type: "input"
                }, null, 8, ["rules", "modelValue"]),
                _createVNode(_component_v_text_field, {
                  style: {"width":"25%","display":"inline-block"},
                  class: "p-[5px]",
                  rules: [rules.city],
                  modelValue: _unref(selectedContact).person.city,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(selectedContact).person.city) = $event)),
                  label: "Stadt",
                  placeholder: "Musterstadt",
                  type: "text"
                }, null, 8, ["rules", "modelValue"]),
                _createVNode(_component_v_textarea, {
                  label: "Text*",
                  hint: "Bitte ausfüllen",
                  modelValue: _unref(selectedContact).message,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(selectedContact).message) = $event)),
                  rules: [rules.required]
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(FullButton, {
              handleClick: submit,
              width: "100",
              title: "Senden",
              colour: "white"
            })
          ]),
          _: 1
        }, 512)
      ])
    ])
  ], 64))
}
}

})